import React from 'react';
import './FirstVisitPopup.css';

const FirstVisitPopup = ({ onClose }) => {
  return (
    <div className="first-visit-popup-overlay">
      <div className="first-visit-popup-content">
        <p>This is our <strong>Earth every few days</strong> — via Sentinel-2 satellite.</p>
        <p>We enhance it from 10m to 1–2m resolution,<br />but <strong>don't expect Google Maps–level high-res detail.</strong></p>
        <p>Enjoy the planet ❤️</p>
        <button onClick={onClose} className="first-visit-popup-button">Got it!</button>
      </div>
    </div>
  );
};

export default FirstVisitPopup;